import { api } from 'helpers/api'
import { useMutation } from 'react-query'

export const useMuteThread = () => {
    return useMutation({
        mutationFn: api.thread.muteThread,
        mutationKey: ['threadMuteToggle'],
    })
}
